<template>
	<transition 
			appear
			:appear-active-class="$_tmlnMsgHdrCrd_styleComponentAnimation()">
		<template v-if="$_tmlnMsgHdrCrd_stateComponentIsInitialized">
			<v-row dense>
				<!-- datetime -->
				<v-col cols="auto">
					<v-chip :color="$_tmlnMsgHdrCrd_styleChipColor"
							:dark="$_tmlnMsgHdrCrd_styleChipDark"
							:label="$_tmlnMsgHdrCrd_styleChipLabel"
							:light="$_tmlnMsgHdrCrd_styleChipLight"
							:outlined="$_tmlnMsgHdrCrd_styleChipOutlined"
							:small="$_tmlnMsgHdrCrd_styleChipSmall"
							:text-color="$_tmlnMsgHdrCrd_styleChipTextColor">
						<v-icon left>event</v-icon>
						<span	class="caption"
								v-text="message['datetime']" />
					</v-chip>
				</v-col>
				<template v-if="message['sender_uid'] != $_tmlnMsgHdrCrd_currentUserUid">
					<!-- sender -->
					<v-col cols="auto">
						<v-chip :color="$_tmlnMsgHdrCrd_styleChipColor"
								:dark="$_tmlnMsgHdrCrd_styleChipDark"
								:label="$_tmlnMsgHdrCrd_styleChipLabel"
								:light="$_tmlnMsgHdrCrd_styleChipLight"
								:outlined="$_tmlnMsgHdrCrd_styleChipOutlined"
								:small="$_tmlnMsgHdrCrd_styleChipSmall"
								:text-color="$_tmlnMsgHdrCrd_styleChipTextColor">
							<v-icon left>person</v-icon>
							<span	class="span_ caption"
									v-text="message['sender_name']" />
						</v-chip>
					</v-col>
				</template>
				<template v-else>
					<!-- to -->
					<template v-if="!isFalse(message['to_uid'])">
						<v-col cols="auto">
							<v-chip :color="$_tmlnMsgHdrCrd_styleChipColor"
									:dark="$_tmlnMsgHdrCrd_styleChipDark"
									:label="$_tmlnMsgHdrCrd_styleChipLabel"
									:light="$_tmlnMsgHdrCrd_styleChipLight"
									:outlined="$_tmlnMsgHdrCrd_styleChipOutlined"
									:small="$_tmlnMsgHdrCrd_styleChipSmall"
									:text-color="$_tmlnMsgHdrCrd_styleChipTextColor">
								<v-icon left>person</v-icon>
								<span	class="span_ caption"
										v-text="message['to_name']" />
							</v-chip>
						</v-col>
					</template>
				</template>
				<!-- title -->
				<v-col cols="auto">
					<template v-if="!isFalse(message['title'])">
						<v-chip :color="$_tmlnMsgHdrCrd_styleChipColor"
								:dark="$_tmlnMsgHdrCrd_styleChipDark"
								:label="$_tmlnMsgHdrCrd_styleChipLabel"
								:light="$_tmlnMsgHdrCrd_styleChipLight"
								:outlined="$_tmlnMsgHdrCrd_styleChipOutlined"
								:small="$_tmlnMsgHdrCrd_styleChipSmall"
								:text-color="$_tmlnMsgHdrCrd_styleChipTextColor">
							<v-icon left>email</v-icon>
							<span	class="caption"
									v-text="message['title']" />
						</v-chip>
					</template>
				</v-col>
			</v-row>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'TimelineMessageHeaderCard',
		props: {
			message: Object
		},
		data() {
			return {
				componentName_: 'timelineMessageHeaderCard',
			}
		},
		computed: {
			// current user
			$_tmlnMsgHdrCrd_currentUserUid() {
				const self_ = this;
				return self_.getCurrentUser('uid')
			},
			// state
			$_tmlnMsgHdrCrd_stateComponentIsInitialized() {
				const self_ = this;
				return self_.getComponentState('isInitialized')
			},
			$_tmlnMsgHdrCrd_statePageTimeline() {
				const self_ = this;
				return self_.getPageState('timeline')
			},
			$_tmlnMsgHdrCrd_statePageTimelineSender() {
				const self_ = this;
				const page_ = self_.$_tmlnMsgHdrCrd_statePageTimeline;
				return page_.sender
			},
			// contents / inits
			$_tmlnMsgHdrCrd_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getComponentContents(self_.componentName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_tmlnMsgHdrCrd_inits() {
				const self_ = this;
				return () => {
					return self_.getComponentInits(self_.componentName_)
				}
			},
			// style
			$_tmlnMsgHdrCrd_styleComponent() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_tmlnMsgHdrCrd_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_tmlnMsgHdrCrd_inits(), 'component')
				}
			},
			$_tmlnMsgHdrCrd_styleComponentAnimation() {
				const self_ = this;
				return () => {
					const component_ = self_.$_tmlnMsgHdrCrd_styleComponent()
					if(self_.isFalse(component_)) { return null }
					return self_.getStylesVal(component_.animation)
				}
			},
			$_tmlnMsgHdrCrd_styleMessageCard() {
				const self_ = this;
				if(self_.isEmpty(self_.$_tmlnMsgHdrCrd_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_tmlnMsgHdrCrd_inits(), 'messageCard')
			},
			$_tmlnMsgHdrCrd_styleMessageCardColor() {
				const self_ = this;
				const messageCard_ = self_.$_tb_styleMessageCard;
				if(self_.isFalse(messageCard_)) { return null }
				return self_.getStylesVal(messageCard_.color)
			},
			$_tmlnMsgHdrCrd_styleMessageCardDark() {
				const self_ = this;
				const messageCard_ = self_.$_tb_styleMessageCard;
				if(self_.isFalse(messageCard_)) { return null }
				return self_.getStylesVal(messageCard_.dark)
			},
			$_tmlnMsgHdrCrd_styleMessageCardElevation() {
				const self_ = this;
				const messageCard_ = self_.$_tb_styleMessageCard;
				if(self_.isFalse(messageCard_)) { return null }
				return self_.getStylesVal(messageCard_.elevation)
			},
			$_tmlnMsgHdrCrd_styleMessageCardFlat() {
				const self_ = this;
				const messageCard_ = self_.$_tb_styleMessageCard;
				if(self_.isFalse(messageCard_)) { return null }
				return self_.getStylesVal(messageCard_.flat)
			},
			$_tmlnMsgHdrCrd_styleMessageCardHover() {
				const self_ = this;
				const messageCard_ = self_.$_tb_styleMessageCard;
				if(self_.isFalse(messageCard_)) { return null }
				return self_.getStylesVal(messageCard_.hover)
			},
			$_tmlnMsgHdrCrd_styleMessageCardLight() {
				const self_ = this;
				const messageCard_ = self_.$_tb_styleMessageCard;
				if(self_.isFalse(messageCard_)) { return null }
				return self_.getStylesVal(messageCard_.light)
			},
			$_tmlnMsgHdrCrd_styleMessageCardOutlined() {
				const self_ = this;
				const messageCard_ = self_.$_tmlnMsgHdrCrd_styleMessageCard;
				if(self_.isFalse(messageCard_)) { return null }
				return self_.getStylesVal(messageCard_.outlined)
			},
			$_tmlnMsgHdrCrd_styleMessageCardRaised() {
				const self_ = this;
				const messageCard_ = self_.$_tmlnMsgHdrCrd_styleMessageCard;
				if(self_.isFalse(messageCard_)) { return null }
				return self_.getStylesVal(messageCard_.raised)
			},
			$_tmlnMsgHdrCrd_styleMessageCardTile() {
				const self_ = this;
				const messageCard_ = self_.$_tmlnMsgHdrCrd_styleMessageCard;
				if(self_.isFalse(messageCard_)) { return null }
				return self_.getStylesVal(messageCard_.tile)
			},
			$_tmlnMsgHdrCrd_styleChip() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.$_tmlnMsgHdrCrd_inits(), 'chip')
			},
			$_tmlnMsgHdrCrd_styleChipColor() {
				const self_ = this;
				const chip_ =self_.$_tmlnMsgHdrCrd_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.color)
			},
			$_tmlnMsgHdrCrd_styleChipDark() {
				const self_ = this;
				const chip_ = self_.$_tmlnMsgHdrCrd_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.dark)
			},
			$_tmlnMsgHdrCrd_styleChipLabel() {
				const self_ = this;
				const chip_ = self_.$_tmlnMsgHdrCrd_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.label)
			},
			$_tmlnMsgHdrCrd_styleChipLight() {
				const self_ = this;
				const chip_ = self_.$_tmlnMsgHdrCrd_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.light)
			},
			$_tmlnMsgHdrCrd_styleChipOutlined() {
				const self_ = this;
				const chip_ = self_.$_tmlnMsgHdrCrd_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.outlined)
			},
			$_tmlnMsgHdrCrd_styleChipSmall() {
				const self_ = this;
				const chip_ = self_.$_tmlnMsgHdrCrd_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.small)
			},
			$_tmlnMsgHdrCrd_styleChipTextColor() {
				const self_ = this;
				const chip_ = self_.$_tmlnMsgHdrCrd_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.textColor)
			}
		}
	}
</script>

<style scoped>
	.span_ {
		margin-left: 8px;
	}
</style>